/* eslint-disable react/display-name */
import React, { useContext } from '../../_snowpack/pkg/react.js';
import { UserContext } from './user-context.js';

function useLanguage() {
  const {
    language,
    setLanguage
  } = useContext(UserContext);
  return {
    language,
    setLanguage
  };
}

export default useLanguage; // eslint-disable-next-line @typescript-eslint/no-explicit-any

export const withLanguage = Component => props => {
  const {
    language,
    setLanguage
  } = useContext(UserContext);
  const composedProps = { ...props,
    language,
    setLanguage
  };
  return /*#__PURE__*/React.createElement(Component, composedProps);
};